import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('add_limit_to_nav3_starred_filter_sidebar');
	},
};
